import { ReactComponent as P1Svg } from '@/panel/desktop/icons/p1.svg';
import { ReactComponent as P2Svg } from '@/panel/desktop/icons/p2.svg';
import { ReactComponent as P3Svg } from '@/panel/desktop/icons/p3.svg';

import { ReactComponent as D1Svg } from '@/panel/desktop/icons/d1.svg';
import { ReactComponent as D2Svg } from '@/panel/desktop/icons/d2.svg';
import { ReactComponent as D3Svg } from '@/panel/desktop/icons/d3.svg';

import { ReactComponent as C1Svg } from '@/panel/desktop/icons/c1.svg';
import { ReactComponent as C2Svg } from '@/panel/desktop/icons/c2.svg';
import { ReactComponent as C3Svg } from '@/panel/desktop/icons/c3.svg';

import { ReactComponent as M1Svg } from '@/panel/desktop/icons/m1.svg';
import { ReactComponent as M2Svg } from '@/panel/desktop/icons/m2.svg';
import { ReactComponent as M3Svg } from '@/panel/desktop/icons/m3.svg';

import { ReactComponent as R1Svg } from '@/panel/desktop/icons/r1.svg';
import { ReactComponent as R2Svg } from '@/panel/desktop/icons/r2.svg';
import { ReactComponent as R3Svg } from '@/panel/desktop/icons/r3.svg';

import { ReactComponent as U1Svg } from '@/panel/desktop/icons/u1.svg';
import { ReactComponent as U2Svg } from '@/panel/desktop/icons/u2.svg';
import { ReactComponent as U3Svg } from '@/panel/desktop/icons/u3.svg';

import { ReactComponent as Z1Svg } from '@/panel/desktop/icons/z1.svg';
import { ReactComponent as Z2Svg } from '@/panel/desktop/icons/z2.svg';
import { ReactComponent as Z3Svg } from '@/panel/desktop/icons/z3.svg';

export const LIB_NAV_LIST = [
    {
        label: '项目列表',
        normalIcon: P1Svg,
        hoverIcon: P2Svg,
        activeIcon: P3Svg,
        url: '/desktop/project-list'
    },
    {
        label: '库'
    },
    {
        label: '设备',
        normalIcon: D1Svg,
        hoverIcon: D2Svg,
        activeIcon: D3Svg,
        url: '/desktop/device'
    },
    // {
    //     label: '计算方法',
    //     normalIcon: C1Svg,
    //     hoverIcon: C2Svg,
    //     activeIcon: C3Svg,
    //     url: '/desktop/calc-func'
    // },
    {
        label: '监测参数',
        normalIcon: M1Svg,
        hoverIcon: M2Svg,
        activeIcon: M3Svg,
        url: '/desktop/monitor-object'
    },
    {
        label: '本构关系',
        normalIcon: R1Svg,
        hoverIcon: R2Svg,
        activeIcon: R3Svg,
        url: '/desktop/relation'
    },
    {
        label: '用户',
        normalIcon: U1Svg,
        hoverIcon: U2Svg,
        activeIcon: U3Svg,
        url: '/desktop/user'
    },
    {
        label: '职位',
        normalIcon: Z1Svg,
        hoverIcon: Z2Svg,
        activeIcon: Z3Svg,
        url: '/desktop/position'
    },
]